<template>
  <div class="carsList_wraps">
    <div class="container">
      <!-- <span @click="active_modal_service=true">open</span> -->
      <!-- <span @click="step2Component()">step 2</span>
      <span @click="openModel_suggistion()">suggg modal</span> -->
      <div class="row">
        <div class="col-xl-4 col-md-6" style="order: -2">
          <!-- Add New Car Box -->
          <div class="box_add_new_car">
            <div
              class="alledy_added_box card dekk_master_add_car"
              data-aos="fade-up"
            >
              <input
                type="checkbox"
                id="card1"
                class="more"
                aria-hidden="true"
              />
              <div class="content">
                <div class="front">
                  <div class="inner">
                    <div class="title_dekk_added_car">
                      <h5 class="nycar">Registrer nytt kjøretøy</h5>
                    </div>
                    <label for="card1" class="button" aria-hidden="true">
                      <span>
                        <i class="bx bx-plus plussAdd"></i>
                      </span>
                    </label>
                  </div>
                </div>
                <div class="back">
                  <div class="inner">
                    <div class="row fx_form">
                      <div class="car-wrap">
                        <!--  @keypress.space.prevent="ValidateRegSearch($event);" -->
                        <div class="car-text-block">
                          <div class="wrapcarlin">
                            <img :src="imgsrc1.src" />
                            <input
                              class="license-number-input regnr carLinces"
                              autocomplete="off"
                              @keypress="ValidateRegSearch($event)"
                              @keyup="length_car_linces()"
                              @focus="focus_carLinces()"
                              @focusout="focusOut_carLinces()"
                              id="carLinces"
                              maxlength="7"
                              v-model="matricule"
                              placeholder="AB 12345"
                              type="text"
                            />
                          </div>
                        </div>

                        <div class="form-group mt-3">
                          <div class="center content-inputs">
                            <vs-select
                              v-if="get_car_type_list.length > 0"
                              placeholder="Vehicle Types"
                              v-model="carTypeValue"
                              color="success"
                            >
                              <vs-option
                                v-for="cartype in get_car_type_list"
                                :label="cartype.name"
                                :value="cartype.id"
                                :key="cartype.id"
                              >
                                {{ cartype.name }}
                              </vs-option>
                            </vs-select>
                          </div>
                        </div>
                        <div class="form-group mt-3">
                          <div class="center content-inputs">
                            <vs-input v-model="brand" placeholder="Merke" />
                          </div>
                        </div>

                        <div class="form-group mt-2">
                          <div class="center content-inputs">
                            <vs-input v-model="model" placeholder="Modell" />
                          </div>
                        </div>
                        <div class="form-group mt-2">
                          <div class="center content-inputs">
                            <vs-input v-model="year" placeholder="Årsmodell" />
                          </div>
                        </div>
                        <div class="form-group mt-2">
                          <div class="center content-inputs">
                            <vs-input v-model="color" placeholder="Farge" />
                          </div>
                        </div>

                        <div class="ag-base-block">
                          <vs-button
                            @click.native="add_new_car()"
                            color="#343a40"
                            gradient
                            square
                            :loading="add_car_loading"
                            :disabled="
                              !full_linces ||
                              matricule == '' ||
                              color == '' ||
                              brand == '' ||
                              model == '' ||
                              year == '' ||
                              carTypeValue == ''
                            "
                          >
                            <span>Save</span>
                          </vs-button>
                        </div>
                      </div>
                    </div>
                    <label
                      for="card1"
                      class="button2 return"
                      aria-hidden="true"
                    >
                      <i class="bx bx-x"></i>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- End New Car Box -->
        </div>
        <template v-if="get_user_car_list.length == 0">
          <div class="no_cars col-xl-8 col-md-6">
            <img src="~@/assets/empty.svg" alt="empty" />
            <p>You don't have cars , add new car</p>
          </div>
        </template>
        <template v-else>
          <template v-for="cars in get_user_car_list">
            <div class="col-xl-4 col-md-6" :key="cars.id">
              <div
                class="alledy_added_box alledy_added_box2 others_added_car uk-card uk-card-hover uk-card-default uk-card-small"
                data-aos="fade-up"
              >
                <VueSkeletonLoader
                  v-show="skelton_cars"
                  class="rects big_cars"
                  type="rect"
                  :width="290"
                  :height="20"
                />
                <div class="cardWrapp wrapup">
                  <div class="card__background"></div>
                  <div class="mobilenav">
                    <ul>
                      <!-- {{cars.reservation.update}} -->
                      <li v-if="cars.reservation">
                        <span
                          v-if="cars.reservation.update"
                          @click="go_service_cart_update(cars.matricule, cars , cars.reservation)"
                          ><i class="fas fa-pencil-alt mr-3"></i>Endre din
                          avtale</span
                        >
                      </li>
                      <li>
                        <span @click="open_modal_delete_cat(cars.id)">
                          <i class="far fa-trash-alt mr-3"></i>Slett din
                          bil</span
                        >
                      </li>
                      <li>
                        <span @click="tracking_car_function(cars.matricule)"
                          ><i class="fas fa-book mr-3"></i>Ordre historikk</span
                        >
                      </li>
                      <!-- <li>
                        <span
                          ><i class="fas fa-book mr-3"></i>Betalings
                          historikk</span
                        >
                      </li>
                      <li>
                        <span
                          ><i class="fas fa-id-card mr-3"></i
                          >Vurderingsskjema</span
                        >
                      </li> -->
                    </ul>
                  </div>
                  <div class="uk-card-body">
                    <div class="text-center pt-1">
                      <div class="infocar text-white">
                        <!-- www Peugeot w 505 GR -->
                        <!-- {{cars}} -->
                        {{ cars.brand }} {{ cars.model }} {{ cars.color }}
                      </div>
                      <div class="infocar2 text-white">
                        <!-- {{ cars.vehicle_type.id }} ,
                        {{ cars.vehicle_type.name }}  -->
                        {{ cars.year }}
                      </div>
                      <div class="wrapcarlin2" style="margin-top: 18px">
                        <img src="~@/assets/carLinces2.png" />
                        <input
                          class="license-number-input regnr"
                          :value="cars.matricule"
                          disabled=""
                          type="text"
                          required=""
                          style="
                            background: linear-gradient(
                              to left,
                              #ffff 88%,
                              #0052c4 22%
                            );
                            border: 2px solid black;
                          "
                        />
                      </div>
                      <!-- @click="step2Component()" -->
                      <template v-if="cars.reservation">
                        <p class="date_reservation_user">
                          <i class="bx bxs-calendar-check bx-tada"></i>
                          <span>
                            {{cars.reservation.reservation_date.split(" ")[0]}}
                            {{ cars.reservation.time_start.split(":")[0]}}:{{ cars.reservation.time_start.split(":")[1]}}
                            </span
                          >
                        </p>
                      </template>
                      <template v-else>
                        <div class="ag-base-block mt-4">
                          <vs-button
                            @click="go_service_cart(cars.matricule, cars)"
                            class="bestillTime"
                            color="#343a40"
                            animation-type="vertical"
                          >
                            Bestill Time
                            <template #animate> Bestill Time </template>
                          </vs-button>
                        </div>
                      </template>
                    </div>
                  </div>

                  <!-- Menu overlay -->
                  <div class="uk-card-footer uk-background-muted">
                    <div
                      @click="show_sidenavbox(cars.id)"
                      :class="`baricon baricon_${cars.id}`"
                    >
                      <a><i class="bx bx-menu"></i></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </template>
      </div>
    </div>
    <!-- modall for delete car -->
    <vs-dialog width="550px" not-center v-model="active_modal_delete">
        <template #header>
          <h4 class="not-margin" style="color:#fff;padding-top:20px">
           Are you sure to delete?
          </h4>
        </template>


        <div class="con-content">
          <p style="color:#fff;padding-top:0px">
           This car will be deleted from your account but you can retrieve it whenever you want
          </p>
        </div>

        <template #footer>
          <div class="con-footer">
           <div class="row justify-content-center pb-2">
            <div class="col-md-4">
               <vs-button danger :loading="loading_delete_car" @click="delete_car_user()" >
              Delete
            </vs-button>
            </div>
            <div class="col-md-4">
                 <vs-button dark shadow @click="active_modal_delete=false" >
              Cancel
            </vs-button>
            </div>
           </div>
          </div>
        </template>
      </vs-dialog>
    <!-- Model for Tracking car reservation -->
    <!-- overflow-hidden -->
    <vs-dialog full-screen v-model="active_modal_tracking">
      <VueSkeletonLoader
        v-show="skelton_big"
        class="rects big_loader"
        type="rect"
        :width="290"
        :height="20"
      />
      <div class="tracking_modell">
        <div class="container-fluid">
          <h1>Your Reservation</h1>
          <div class="center">
            <vs-table>
              <template #thead>
                <vs-tr>
                  <vs-th> Id </vs-th>
                  <vs-th> Status </vs-th>
                  <vs-th> Paid </vs-th>
                  <vs-th> Reservation Date </vs-th>
                  <vs-th> Total </vs-th>
                </vs-tr>
              </template>
              <template #tbody>
                <vs-tr
                  :key="i"
                  v-for="(tr, i) in get_tracking_car_list.data"
                  :data="tr"
                >
                  <vs-td>
                    {{ tr.reservation.id }}
                  </vs-td>
                  <vs-td>
                    {{ tr.reservation.status }}
                  </vs-td>
                  <vs-td>
                    {{ tr.reservation.paid }}
                  </vs-td>
                  <vs-td>
                    {{ tr.reservation.reservation_date }}
                  </vs-td>
                  <vs-td>
                    {{ tr.reservation.total }}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
      </div>
    </vs-dialog>
  </div>
</template>

<script>
import $ from "jquery";
import VueSkeletonLoader from "skeleton-loader-vue";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "carsListApp",
  data() {
    return {
      imgsrc1: { name: "test1", src: require("../../assets/carLinces.png") },
      imgsrc2: { name: "test2", src: require("../../assets/carLinces2.png") },
      carTypeValue: "",
      matricule: "", // car number in form register car
      brand: "",
      model: "",
      year: "",
      color: "",
      full_linces: false,
      active_modal_tracking: false,
      active_modal_delete:false,
      carTypeIdSelected: "",
      skelton_big: false,
      skelton_load: false,
      skelton_cars: false,
      add_car_loading: false,
      car_id_delete:'',
      loading_delete_car:false,
    };
  },
  components: { VueSkeletonLoader },
  computed: {
    ...mapGetters({
      get_user_car_list: "get_user_car_list",
      get_add_new_car: "get_add_new_car",
      get_car_type_list: "get_car_type_list",
      get_delete_car_res: "get_delete_car_res",
      get_car_info_list: "get_car_info_list",
      get_tracking_car_list: "get_tracking_car_list",
    }),
    getCarTypeId_selected() {
      return this.carTypeIdSelected;
    },
  },
  methods: {
    ...mapActions({
      user_car_list_api: "user_car_list_api",
      add_user_car_api: "add_user_car_api",
      get_car_type_api: "get_car_type_api",
      delete_car_api: "delete_car_api",
      get_car_info_api: "get_car_info_api",
      tracking_car_api: "tracking_car_api",
    }),
    focus_carLinces() {
      console.log("ok");
      $(".wrapcarlin").find("img").attr("src", this.imgsrc2.src);
      $(".wrapcarlin").find("img").css("top", "19px");
    },
    focusOut_carLinces() {
      if ($("#carLinces").val().length < 7) {
        $(".wrapcarlin").find("img").attr("src", this.imgsrc1.src);
        $(".wrapcarlin").find("img").css("top", "15px");
      }
    },
    ValidateRegSearch(event) {
      //
      var k = event ? event.which : window.event.keyCode;
      console.log(event ? event.which : window.event.keyCode);
      if (k === 32) {
        event.preventDefault();
        return false;
      }
      var englishAlphabetAndWhiteSpace = /[A-Za-z0-9]/g;
      var key = String.fromCharCode(event.which);
      if (!englishAlphabetAndWhiteSpace.test(key)) {
        event.preventDefault();
        return false;
      }
      if ($("#carLinces").val().length >= 2) {
        if (k > 31 && (k < 48 || k > 57)) {
          event.preventDefault();
          return false;
        }
      } else if (
        $("#carLinces").val().length == 0 ||
        $("#carLinces").val().length == 1
      ) {
        if (
          !((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8) &&
          !(k > 31 && (k < 48 || k > 57))
        ) {
          event.preventDefault();
          return false;
        }
      }
    },
    length_car_linces() {
      console.log($("#carLinces").val().length);
      if ($("#carLinces").val().length == 7) {
        this.full_linces = true;
        $("#carLinces").addClass("no");
        $("#carLinces").removeClass("nb");
        $("#carLinces").css(
          "background",
          "linear-gradient(to left ,#ffff 88%, #0052c4 22%)"
        );
        $("#carLinces").css("border", "2px solid black");
        this.write_car_number();
      } else if ($("#carLinces").val().length < 7) {
        this.full_linces = false;
        this.brand = "";
        this.model = "";
        this.year = "";
        this.color = "";
        $("#carLinces").css("background", "white");
        $("#carLinces").css("border", "2px solid transparent");
      }
    },
    show_sidenavbox(car_id) {
      $(`.baricon_${car_id}`)
        .parents(".alledy_added_box")
        .find(".mobilenav")
        .toggleClass("slideInMobileNav");
      $(`.baricon_${car_id}`)
        .parents(".alledy_added_box")
        .find(".baricon i")
        .toggleClass("bx bx-menu bx bx-x");
    },
    step2Component() {
      // let my_reservation = {
      //   services: my_service,
      //   matricule: this.matricule_is_selected,
      //   total_price: this.total_all_all_price,
      //   status: true,
      //   invoice: this.all_service_slected,
      //   car_info: this.carinfo_selected,
      // };
      // console.log(my_reservation, "my reservation");
      // this.$emit("clicked", my_reservation);
    },
    add_new_car() {
      this.add_car_loading = true;
      let new_car = {
        vehicle_type_id: this.carTypeValue,
        matricule: this.matricule,
        brand: this.brand,
        model: this.model,
        year: this.year,
        color: this.color,
      };
      let mynum_car = this.matricule;
      this.add_user_car_api(new_car).then(() => {
        this.carTypeValue = "";
        this.matricule = "";
        this.brand = "";
        this.model = "";
        this.year = "";
        this.color = "";
        $("#carLinces").css("background", "white");
        $("#carLinces").css("border", "2px solid transparent");
        this.add_car_loading = false;
        $("#card1").prop("checked", false);
        this.user_car_list_api().then(() => {
          this.openNotification(
            "bottom-right",
            "success",
            "succeeded",
            `The new car ${mynum_car}  has been added to your account`
          );
          // $(".row .alledy_added_box2:last")
          //   .parents(".col-xl-4 ")
          //   .addClass("order1")
          //   .fadeIn();
          mynum_car = "";
        });
      });
    },
    delete_car_user() {
      this.loading_delete_car = true;
      this.delete_car_api(this.car_id_delete).then(() => {
        if (this.get_delete_car_res.status == true) {
          this.user_car_list_api().then(() => {
            this.openNotification(
              "bottom-right",
              "success",
              "succeeded",
              `This Car has been deleted from your account .`
            );
            this.loading_delete_car = false;
            this.active_modal_delete = false;
          });
        }
      });
    },
    open_modal_delete_cat(car_id){
      this.active_modal_delete = true;
      this.car_id_delete = car_id;
    },
    write_car_number() {
      this.get_car_info_api(this.matricule).then(() => {
        this.brand = this.get_car_info_list.brand;
        this.model = this.get_car_info_list.model;
        this.color = this.get_car_info_list.color;
        this.year = this.get_car_info_list.year;
      });
    },
    tracking_car_function(car_number) {
      console.log(car_number);
      this.tracking_car_api(car_number).then(() => {
        if (this.get_tracking_car_list.status == 200) {
          this.active_modal_tracking = true;
        } else {
          this.openNotification(
            "bottom-right",
            "danger",
            "There is no record",
            `There is no prior record of this car.`
          );
        }
      });
    },
    go_service_cart(car_number, cars_info) {
      $("html, body").animate({ scrollTop: 0 }, "slow");
      let config_next_component = {
        carlist: false,
        service_cart: true,
        suggestion_cart: false,
        calender: false,
        car_number: car_number,
        car_info: cars_info,
      };
      this.$emit("clicked", config_next_component);
    },
      go_service_cart_update(car_number, cars_info , car_reservation) {
      $("html, body").animate({ scrollTop: 0 }, "slow");
      let config_next_component = {
        carlist: false,
        service_cart: true,
        suggestion_cart: false,
        calender: false,
        car_number: car_number,
        car_info: cars_info,
        car_reservation:car_reservation
      };
      this.$emit("clicked", config_next_component);
    },
    // Notifucation
    openNotification(position = null, color, title, text) {
      this.$vs.notification({
        color,
        position,
        title: title,
        text: text,
      });
    },
  },
  mounted() {
    this.get_car_type_api();
    this.skelton_cars = true;
    this.user_car_list_api().then(() => {
      this.skelton_cars = false;
    });
    // this.get_service_by_category_api(1);
    // this.active_modal_service = true;
  },
};
</script>
<style lang="scss" scoped>
.carsList_wraps {
  padding-top: 40px;
  padding-bottom: 80px;
  input {
    min-height: unset;
  }
  .fx_form {
    margin: 0 auto;
    padding-top: 0px;
  }
  .bestillTime {
    font-size: 20px;
    padding: 4px 0px;
    width: 80%;
    margin: 0 auto;
    margin-top: 50px;
    border-radius: 0;
  }
  .no_cars {
    text-align: center;
    padding-top: 30px;
    img {
      width: 100%;
      height: 340px;
    }
    p {
      padding-top: 30px;
      font-size: 16px;
      font-weight: 500;
    }
  }
}
.order1 {
  order: -1;
}
.date_reservation_user {
  position: relative;
  color: var(--active_color);
  padding-top: 55px;
  font-size: 1.4rem;
  font-weight: 500;
}
.flex_key {
  display: flex;
  flex: 0 0 100%;
}
.title_suggesion {
  padding-top: 25px;
  font-size: 2rem;
  font-weight: 500;
  letter-spacing: 0.5px;
  text-transform: capitalize;
}
.save_order {
  position: fixed;
  bottom: 50px;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
}
.front {
  background: url("~@/assets/addnew.webp");
  background-position: center;
  background-size: cover;
}
</style>
